import PropTypes from 'prop-types'
import { Component, createRef } from 'react'
import DateTimeInput from 'react-datetime'

import 'react-datetime/css/react-datetime.css'

import defaultProps from '@/components/Form/defaultProps'
import propTypes from '@/components/Form/propTypes'
import { Calendar, Clock } from '@/components/Icons'

import './index.scss'

class DateTime extends Component<any, any> {
  static displayName = 'DateTime'

  static propTypes = {
    ...propTypes,
    disabled: PropTypes.bool,
    isDatePicker: PropTypes.bool,
    isTimePicker: PropTypes.bool,

    /**
     * optional callback for each date visible in a picker to determine if it's a valid selection or not. function takes
     * arguments of `currentDate`, which is the date to validate, and `selectedDate`, the already selected value in the
     * picker, and must return a boolean
     */
    isValidDate: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    showIcon: PropTypes.bool
  }

  static defaultProps = {
    ...defaultProps,
    disabled: false,
    isDatePicker: true,
    isTimePicker: true,
    isValidDate: () => true,
    onBlur: () => {},
    onChange: () => {},
    required: false,
    showIcon: true
  }

  ref: any

  constructor(props: any) {
    super(props)
    this.ref = createRef()
  }

  onIconClick = () => {
    if (this.props.disabled) {
      return
    }
    this.ref.current.openCalendar()
  }

  renderInputWithIcon = (props: any) => {
    const Icon = !this.props.isDatePicker && this.props.isTimePicker ? Clock : Calendar
    return (
      <div>
        <Icon onClick={this.onIconClick} />
        <input {...props} />
      </div>
    )
  }

  render() {
    const { disabled, id, isDatePicker, isTimePicker, isValidDate, onBlur, onChange, required, showIcon, value } =
      this.props
    const renderInputProp: { renderInput?: (props: any) => JSX.Element } = {}
    const classNames: string[] = []

    if (showIcon) {
      renderInputProp.renderInput = this.renderInputWithIcon
    }

    if (isDatePicker) {
      classNames.push('date')
    }

    if (isTimePicker) {
      classNames.push('time')
    }

    return (
      <div className="form__datepicker_group">
        <DateTimeInput
          {...renderInputProp}
          closeOnSelect
          dateFormat={isDatePicker}
          inputProps={{
            className: `form__datepicker_input field__input ${classNames.join(' ')}`,
            disabled,
            id,
            required,
            autoComplete: 'off'
          }}
          isValidDate={isValidDate}
          onBlur={onBlur}
          onChange={onChange}
          ref={this.ref}
          timeFormat={isTimePicker}
          value={value}
        />
      </div>
    )
  }
}

export default DateTime
